import script from "./deals-list.vue?vue&type=script&setup=true&lang=js"
export * from "./deals-list.vue?vue&type=script&setup=true&lang=js"

import "./deals-list.vue?vue&type=style&index=0&id=9a2bb76a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a2bb76a"]])

export default __exports__